<template>
  <div>
    <Form ref="slideInfo" :model="slideInfo" :label-width="100" :rules="ruleSlide">
      <FormItem :label="$t('editCase.slideNumber')" prop="slide_code" class="case-detail-form-item">
        <Input v-model="slideInfo.slide_code" maxlength="20"></Input>
      </FormItem>
      <!--<FormItem label="分析类型：" prop="pathology_type" class="case-detail-form-item">
        <Select v-model="slideInfo.pathology_type">
          <Option v-for="item in fxffList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>-->
    </Form>
    <div slot="footer" style="text-align: right;">
      <Button type="primary" size="large" @click.native="newSliFormValidate('slideInfo')">{{$t('editCase.save')}}</Button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['fxffList', 'sampleId', 'rslxList'],
  data () {
    return {
      slideInfo: {
        slide_code: ''
      },
      ruleSlide: {
        slide_code: [
          { required: true, message: this.$t('editCase.slideNumberTip'), trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount () {
    this.$vue = this
  },
  methods: {
    newSliFormValidate (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveNewSlide()
        } else {
          this.warning()
        }
      })
    },
    async saveNewSlide () {
      let params = new URLSearchParams()
      params.append('sample_id', this.sampleId)
      params.append('slideInfo', JSON.stringify(this.slideInfo))
      let suc = await this.$http.post(this.$vue.getData('GET_ADD_SAMPLE_SLIDE_URL'), params)
      if (suc.data.result === '1') {
        this.$emit('reLoadSampleSlideList')
        this.success()
      } else {
        this.warning()
      }
    },
    // 保存成功消息提醒
    success () {
      this.$Notice.success({
        title: this.$t('caseList.messageNotification'),
        desc: this.$t('editCase.successfullyAddedSlideTip')
      })
    },
    // 保存失败消息提醒
    warning () {
      this.$Notice.error({
        title: this.$t('caseList.messageNotification'),
        desc: this.$t('editCase.failedToAddSlideTip')
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/case/caseManager/caseDetail/AddNewSlide.vue